import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history?${p}`);
  },
  exportToExcel(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history?${p}`, {
      responseType: "blob",
    });
  },
};
